import React from "react";
import config from "./config";
import "./index.scss";
import { GenericHeroProps } from "../HomepageHeroV2/index";

interface Component {
  name: string;
  props?: GenericHeroProps | any;
  sortMobile: number;
}

export default ({ componentList }: { componentList: Component[] }) => {
  let names = Object.keys(config);

  const modules = componentList
    .filter(comp => names.some(key => key == comp.name))
    .map(component => {
      if (component.name === "homeHeroCarouselModule")
        return {
          ...component,
          props: { slide: component.props.items[0], ...component.props }
        };
      return component;
    })
    .map(component => {
      return {
        sort: component.sortMobile,
        props: component.props,
        span: config[component.name].columnSpan,
        row: config[component.name].rowSpan,
        Component: config[component.name].Component
      };
    });
  return (
    <div
      className={`container grid__module-wrapper${
        modules.some(mod => mod.row > 1) ? " wide" : ""
      }`}
    >
      {modules.map(
        (
          {
            Component,
            props,
            span,
            sort,
            row
          }: {
            Component: React.FC;
            props?: GenericHeroProps;
            span: number | string;
            sort: number;
            row: number | string;
          },
          key: number
        ) => {
          if (Component.name == "GenericHero") {
            return (
              <div
                className={`grid__module module--${key} homepage-main-image span-${span} sort-${sort} row-${row}`}
              >
                <Component {...props} key={key} />
              </div>
            );
          }

          return (
            <div
              className={`grid__module module--${key} span-${span} sort-${sort} row-${row}`}
            >
              <Component {...props} key={key} />
            </div>
          );
        }
      )}
    </div>
  );
};
